/**
 * Avatar color palette with good contrast for white text
 */
const AVATAR_COLORS = [
  '#4F46E5', // Indigo
  '#7C3AED', // Purple
  '#EC4899', // Pink
  '#EF4444', // Red
  '#F97316', // Orange
  '#EAB308', // Yellow
  '#22C55E', // Green
  '#14B8A6', // Teal
]

/**
 * Get a consistent color for an avatar based on the name
 * Same name will always return the same color
 */
export function getAvatarColor(name: string): string {
  if (!name || name.trim() === '') {
    return AVATAR_COLORS[0]
  }

  const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

/**
 * Get the first letter/initial from a name for avatar display
 */
export function getInitial(name: string): string {
  if (!name || name.trim() === '') {
    return '?'
  }

  return name.trim().charAt(0).toUpperCase()
}
